
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/troubleshooting",
      function () {
        return require("private-next-pages/events/troubleshooting.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/troubleshooting"])
      });
    }
  